import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import './ThemeToggle.css';

const SCHEMES = [
  { id: 'light', label: 'Default', colors: ['#FFE8D6', '#FF90E8', '#2D3436'] },
  { id: 'dark', label: 'Night', colors: ['#14111c', '#e4a8e6', '#f2cf6b'] },
  { id: 'chocolate', label: 'Chocolate truffle', colors: ['#713600', '#C05800', '#FDFBD4'] },
  { id: 'ink', label: 'Ink wash', colors: ['#4A4A4A', '#CBCBCB', '#6D8196'] },
  { id: 'taupe', label: 'Golden taupe', colors: ['#D4AF37', '#BDB76B', '#CE8946'] },
];

const ThemeToggle = ({ className = '' }) => {
  const { theme, setTheme } = useTheme();
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const current = SCHEMES.find((scheme) => scheme.id === theme) || SCHEMES[0];

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    const onPointer = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener('keydown', onKey);
    document.addEventListener('mousedown', onPointer);
    return () => {
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('mousedown', onPointer);
    };
  }, [open]);

  return (
    <div className={`scheme-picker ${className}`.trim()} ref={rootRef}>
      <button
        type="button"
        className="theme-toggle"
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={`Color scheme: ${current.label}`}
        title="Color scheme"
        onClick={() => setOpen((value) => !value)}
      >
        <span className="scheme-swatch" aria-hidden="true">
          {current.colors.map((color) => (
            <span key={color} style={{ background: color }} />
          ))}
        </span>
      </button>
      {open && (
        <ul className="scheme-menu" role="listbox" aria-label="Color scheme">
          {SCHEMES.map((scheme) => (
            <li key={scheme.id}>
              <button
                type="button"
                role="option"
                aria-selected={scheme.id === theme}
                className={`scheme-option ${scheme.id === theme ? 'is-selected' : ''}`}
                onClick={() => {
                  setTheme(scheme.id);
                  setOpen(false);
                }}
              >
                <span className="scheme-swatch" aria-hidden="true">
                  {scheme.colors.map((color) => (
                    <span key={color} style={{ background: color }} />
                  ))}
                </span>
                <span className="scheme-label">{scheme.label}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ThemeToggle;
